export default class Center
{
    constructor(instructions, basic_info,volunteer_works){
        this.instructions       = instructions
        this.basic_info     = basic_info
        this.volunteer_works = volunteer_works
    }

    toFormData(){
        let fData = new FormData()
        
        //معلومات المتقدم    
        fData.append('name1', this.basic_info.name1);
        fData.append('name2', this.basic_info.name2);
        fData.append('name3', this.basic_info.name3);
        fData.append('name4', this.basic_info.name4);
        fData.append('family_name', this.basic_info.family_name);
        fData.append('birth_date', this.basic_info.birth_date);
        fData.append('phone', this.basic_info.phone1);
        fData.append('gender_id', this.basic_info.gender_id);
        fData.append('marital_status_id', this.basic_info.marital_status_id);
        fData.append('job_id', this.basic_info.job);
        fData.append('address_district', this.basic_info.district);
        fData.append('address_currrent', this.basic_info.current_place);
        fData.append('address_nearest_point', this.basic_info.nearest_point);
        fData.append('address_city_id', this.basic_info.city_id);
        fData.append('certificate_id', this.basic_info.certificate_id);
        if([8,9,10,11,12].findIndex((a)=>a==this.basic_info.certificate_id)>=0){
            fData.append('level_id', this.basic_info.level_id);
            fData.append('university', this.basic_info.university);
            fData.append('college', this.basic_info.college);
        }

        alert(this.volunteer_works.language_id)
       //المهارات والاعمال التطوعية
        for (let i = 0; i < this.volunteer_works.language_id.length; i++) {
            const element = this.volunteer_works.language_id[i];
            fData.append('langs['+i+']', element.id);            
        }
        fData.append('question_1_skills', this.volunteer_works.skills);
        fData.append('question_2_contributions', this.volunteer_works.contributions);
        fData.append('question_3_friends', this.volunteer_works.friends);
        fData.append('question_4_link', this.volunteer_works.link);
        fData.append('question_5_experience', this.volunteer_works.experience);
        fData.append('question_6_services', this.volunteer_works.services);
        fData.append('question_7_hours_days', this.volunteer_works.hours_days);
        fData.append('details', this.volunteer_works.details);
        
        fData.append('link_telegram', this.volunteer_works.telegram);
        fData.append('link_facebook', this.volunteer_works.facebook);
        fData.append('link_instagram', this.volunteer_works.instagram);
        fData.append('link_twitter', this.volunteer_works.twitter);
        
        return fData
    }
}

